
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {Position} from '../core/Position';
import {FieldModelPosition} from '../core/Position';

/**
 * PositionInsert2Response struct
 */
class PositionInsert2Response extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Position=} position
   * @constructor
   */
  constructor (parent = new Response(), position = new Position()) {
    super()
    super.copy(parent)
    this.Position = position
  }

  /**
   * Copy struct (shallow copy)
   * @this {!PositionInsert2Response}
   * @param {!PositionInsert2Response} other Other struct
   * @returns {!PositionInsert2Response} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Position != null) {
      this.Position = Position.fromObject(other.Position)
    } else {
      this.Position = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!PositionInsert2Response}
   * @returns {!PositionInsert2Response} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new PositionInsert2ResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new PositionInsert2ResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!PositionInsert2Response}
   * @param {!PositionInsert2Response} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof PositionInsert2Response)) {
      throw new TypeError('Instance of PositionInsert2Response is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!PositionInsert2Response}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Position: ((this.Position != null) ? this.Position : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return PositionInsert2Response.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!PositionInsert2Response} other Object value
   * @returns {!PositionInsert2Response} Created struct
   */
  static fromObject (other) {
    return new PositionInsert2Response().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!PositionInsert2Response}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return PositionInsert2Response.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!PositionInsert2Response}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4076
  }
}

export { PositionInsert2Response };

/**
 * Fast Binary Encoding PositionInsert2Response field model
 */
class FieldModelPositionInsert2Response extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.Position = new FieldModelPosition(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelPositionInsert2Response}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelPositionInsert2Response}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelPositionInsert2Response}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Position.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelPositionInsert2Response}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Position.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelPositionInsert2Response}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelPositionInsert2Response.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelPositionInsert2Response}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4076
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelPositionInsert2Response}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelPositionInsert2Response}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Position.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Position.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Position.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelPositionInsert2Response}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelPositionInsert2Response}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelPositionInsert2Response}
   * @param {!PositionInsert2Response} fbeValue Default value, defaults is new PositionInsert2Response()
   * @returns {!PositionInsert2Response} PositionInsert2Response value
   */
  get (fbeValue = new PositionInsert2Response()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelPositionInsert2Response}
   * @param {!PositionInsert2Response} fbeValue PositionInsert2Response value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Position.fbeSize) <= fbeStructSize) {
      fbeValue.Position = this.Position.get()
    } else {
      fbeValue.Position = new Position()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Position.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelPositionInsert2Response}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelPositionInsert2Response}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelPositionInsert2Response}
   * @param {!PositionInsert2Response} fbeValue PositionInsert2Response value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelPositionInsert2Response}
   * @param {PositionInsert2Response} fbeValue PositionInsert2Response value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Position.set(fbeValue.Position)
  }
}

export { FieldModelPositionInsert2Response };

/**
 * Fast Binary Encoding PositionInsert2Response model
 */
class PositionInsert2ResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelPositionInsert2Response(this.buffer, 4)
  }

  /**
   * Get the PositionInsert2Response model
   * @this {!PositionInsert2ResponseModel}
   * @returns {!FieldModelPositionInsert2Response} model PositionInsert2Response model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!PositionInsert2ResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!PositionInsert2ResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return PositionInsert2ResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!PositionInsert2ResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelPositionInsert2Response.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!PositionInsert2ResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!PositionInsert2ResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!PositionInsert2ResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!PositionInsert2ResponseModel}
   * @param {!PositionInsert2Response} value PositionInsert2Response value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!PositionInsert2ResponseModel}
   * @param {!PositionInsert2Response} value PositionInsert2Response value, defaults is new PositionInsert2Response()
   * @return {!object} Deserialized PositionInsert2Response value and its size
   */
  deserialize (value = new PositionInsert2Response()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new PositionInsert2Response(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new PositionInsert2Response(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!PositionInsert2ResponseModel}
   * @param {!number} prev Previous PositionInsert2Response model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { PositionInsert2ResponseModel };
